import React from 'react'
import Grid from '@material-ui/core/Grid/Grid'
import Classeur from '../../Component/SuiviDossier/Classeur'
import Flag from '../../Component/SuiviDossier/Flag'
import Utils from 'EurestoFonction/Utils'
import Bus from 'EurestoClass/Bus'
import Messagerie from '../../Component/SuiviDossier/Messagerie/'


export default (class extends React.Component {

  state = {
    UserTabSelected: 0,
    busGUID: Utils.uuidv4()
  }

  crmConfiguration = [
    {
      component: <Flag/>
    },
    {
      component: <Classeur/>
    },
    {
      component: <Messagerie/>
    },
  ]

  componentWillUnmount () {
    Bus.$off('donnees_annexes_sdd',this.state.busGUID)
  }

  componentDidMount () {
    Bus.$on('donnees_annexes_sdd', id=> {
      this.setState({UserTabSelected: id})
    }, this.state.busGUID)
  }

  render () {
    return <Grid container style={{ margin: 0, padding: 0, width: '100%' }} spacing={0}>
      <Grid item xs={12} style={{ margin: 0, padding: 0 }}>
        {
          this.crmConfiguration[this.state.UserTabSelected].component
        }
      </Grid>
    </Grid>
  }
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Page/SDD/index.js